// import Vue from 'vue'
import locale from './locale/index.js'
import MetaData from './MetaData.vue'
import EleForm from 'vue-ele-form'

import MdSetForm from './components/MdSetForm'
import MdSetList from './components/MdSetList'
import MdCategory from './components/MdCategory'
import MdMainWrap from './components/MdMainWrap'
import MdSetDialog from './components/MdSetDialog'
import MdEditModule from './components/MdEditModule'
import MdSetPreview from './components/MdSetPreview'
import MdSubsetForm from './components/MdSubsetForm'
import MdUploadFile from './components/MdUploadFile'
import MdCategoryTag from './components/MdCategoryTag'
import MdElementForm from './components/MdElementForm'
import MdElementList from './components/MdElementList'
import MdRangeSelect from './components/MdRangeSelect'
import MdCustomModule from './components/MdCustomModule'
import MdElementSelect from './components/MdElementSelect'
import MdSetSubsetList from './components/MdSetSubsetList'
import MdCategoryDialog from './components/MdCategoryDialog'
import MdSetElementList from './components/MdSetElementList'
import MdElementResource from './components/MdElementResource'
import MdSetModuleDialog from './components/MdSetModuleDialog'
import MdElementValueList from './components/MdElementValueList'
import MdImportToSetDialog from './components/MdImportToSetDialog'
import MdImportFromElementDialog from './components/MdImportFromElementDialog'

const components = [
  { id: 'meta-data', component: MetaData },
{ id: 'md-set-form', component: MdSetForm },
{ id: 'md-set-list', component: MdSetList },
{ id: 'md-category', component: MdCategory },
{ id: 'md-main-wrap', component: MdMainWrap },
{ id: 'md-set-dialog', component: MdSetDialog },
{ id: 'md-edit-module', component: MdEditModule },
{ id: 'md-set-preview', component: MdSetPreview },
{ id: 'md-subset-form', component: MdSubsetForm },
{ id: 'md-upload-file', component: MdUploadFile },
{ id: 'md-category-tag', component: MdCategoryTag },
{ id: 'md-element-form', component: MdElementForm },
{ id: 'md-element-list', component: MdElementList },
{ id: 'md-range-select', component: MdRangeSelect },
{ id: 'md-custom-module', component: MdCustomModule },
{ id: 'md-element-select', component: MdElementSelect },
{ id: 'md-set-subset-list', component: MdSetSubsetList },
{ id: 'md-category-dialog', component: MdCategoryDialog },
{ id: 'md-set-element-list', component: MdSetElementList },
{ id: 'md-element-resource', component: MdElementResource },
{ id: 'md-set-module-dialog', component: MdSetModuleDialog },
{ id: 'md-element-value-list', component: MdElementValueList },
{ id: 'md-import-to-set-dialog', component: MdImportToSetDialog },
{ id: 'md-import-from-element-dialog', component: MdImportFromElementDialog }
]
const install = function (Vue, opts = {}, lang) {
  if (install.installed) return
  install.installed = true
  Vue.component('md-slot-shim', {
    functional: true,
    props: { render: Function, data: Object },
    render: function (h, ctx) {
      return ctx.props.render(h, ctx.props.data)
    }
  })
  components.forEach(item => {
    Vue.component(item.id, item.component)
  })
  Vue.use(EleForm)
  if (opts['oecp-auth']) {
    Vue.directive('oecp-auth', opts['oecp-auth'])
  } else {
    Vue.directive('oecp-auth', {
      inserted: function (el, binding, vnode) {
        // if (binding.value === 'config.tablesList.rowDel') {
        //   console.log(binding.arg, binding.value)
        //   el.style.display = 'none'
        //   vnode.elm.parentElement.removeChild(vnode.elm)
        // }
      }
    })
  }
  locale.use(lang)
  // 全局的事件
  Vue.prototype.$OecpMetaDataEventBus = new Vue({
    data: function () {
      let res, rej
      const promise = new Promise((resolve, reject) => { [res, rej] = [resolve, reject] })
      return {
        history: [],
        component: { componentName: '', attrs: {} },
        ready: { promise, resolve: res, reject: rej }
      }
    }
  })
  Vue.prototype.$OecpMetaDataConfig = Vue.observable({ ...opts })
  // eslint-disable-next-line quotes
  try { console[console.info ? 'info' : 'log']('%coecp-meta-data-new@0.1.53', 'background: #0068B7; padding: 4px; font-weight: bold; color: white') } catch (error) {}
}

MetaData.install = install
MetaData.version = '0.1.53'
if (typeof window !== 'undefined' && window.Vue) {
  window.MetaData = MetaData
  install(window.Vue, window.OecpMetaDataConfig || {})
}
export default MetaData
